module.exports = __webpack_public_path__ + "img/icon-close.13713337.svg";